import React from "react";
import '../styles/App.css'; // Import your CSS file
import Sidebar from "../components/Sidebar"; // Import your Sidebar component

const Wiki = () => {
    return (
        <div className="content">
        <Sidebar />
        <div className="main-content">
            <h1>Wiki</h1>
            <p>Welcome to the ISN Network Wiki! Here you will find a wealth of information about our platform, including guides, FAQs, and more.</p>
            <div className="wiki-item">
                <h2>Getting Started</h2>
                <p>This section will help you get started with ISN Network, including account creation and navigation tips.</p>
            </div>
            <div className="wiki-item">
                <h2>Community Guidelines</h2>
                <p>Learn about our community guidelines and how to contribute positively to the ISN Network.</p>
            </div>
        </div>
        </div>
    );
}
export default Wiki;